/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { OnboardingThirdParty } from './OnboardingThirdParty';
import {
    OnboardingThirdPartyFromJSON,
    OnboardingThirdPartyFromJSONTyped,
    OnboardingThirdPartyToJSON,
    OnboardingThirdPartyToJSONTyped,
} from './OnboardingThirdParty';

/**
 * 
 * @export
 * @interface GetOnboardingThirdPartiesResponse
 */
export interface GetOnboardingThirdPartiesResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetOnboardingThirdPartiesResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<OnboardingThirdParty>}
     * @memberof GetOnboardingThirdPartiesResponse
     */
    onboardingThirdParties: Array<OnboardingThirdParty>;
}

/**
 * Check if a given object implements the GetOnboardingThirdPartiesResponse interface.
 */
export function instanceOfGetOnboardingThirdPartiesResponse(value: object): value is GetOnboardingThirdPartiesResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('onboardingThirdParties' in value) || value['onboardingThirdParties'] === undefined) return false;
    return true;
}

export function GetOnboardingThirdPartiesResponseFromJSON(json: any): GetOnboardingThirdPartiesResponse {
    return GetOnboardingThirdPartiesResponseFromJSONTyped(json, false);
}

export function GetOnboardingThirdPartiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOnboardingThirdPartiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'onboardingThirdParties': ((json['onboardingThirdParties'] as Array<any>).map(OnboardingThirdPartyFromJSON)),
    };
}

export function GetOnboardingThirdPartiesResponseToJSON(json: any): GetOnboardingThirdPartiesResponse {
    return GetOnboardingThirdPartiesResponseToJSONTyped(json, false);
}

export function GetOnboardingThirdPartiesResponseToJSONTyped(value?: GetOnboardingThirdPartiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'onboardingThirdParties': ((value['onboardingThirdParties'] as Array<any>).map(OnboardingThirdPartyToJSON)),
    };
}

